import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const ContainerSm = styled.div`
  min-width: 302px;
  height: 90px;
  background-color: #EEEEEE;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  border-radius: 4px;
`;

export const Content = styled(Box)`
  height: 85px;
  background-color: var(--grayLv6);
  padding: 24px 20px !important;
  border-radius: 4px;

  @media(min-width: 1920px) {
    height: 98px;
  }
`;

export const Title = styled.span`
  display: inline-block;
  width: 48px;
  font-size: 1.4rem;
  color: var(--black);
  
  @media(min-width: 1920px) {
    font-size: 1.6rem;
  }
`;

interface ValueProps {
  color: string;
}
export const Value = styled.span<ValueProps>`
  color: ${({ color }) => color ? `var(--${color})` : 'var(--color-text)'};
  font-size: 2.4rem;
  font-family: 'OpenSans-Bold';
  
  @media(min-width: 1920px) {
    font-size: 2.8rem;
  }
`;